export const PAYMENT_INFO = (amount) =>
  amount === -1
    ? "unlimited"
    : amount % 10 === 1 && amount % 10 !== 11
    ? `one_training_left`
    : amount % 10 > 1 && amount % 10 < 5
    ? `few_trainings_left`
    : `lot_trainings_left`;
